// Better-auth catch-all route handler — handles /api/auth/sign-in, /sign-up, /sign-out, etc.
import { auth } from "@/lib/auth";
import { toNextJsHandler } from "better-auth/next-js";

export const { POST, GET } = toNextJsHandler(auth);
